interface Props {
  children?: any;
  className?: string;
}

export function ContentParagraph({ children, className = '' }: Props) {
  return <p className={`max-w-full text-base/7 text-brand-content  ${className}`}>{children}</p>;
}
